<template>
  <div class="py-2">
    <template v-if="link">
      <a :href="`/fields/${id}`" class="text-sm font-medium text-primary-60">
        <slot />
      </a>
    </template>
    <template v-else>
      <div class="text-sm text-neutral-40">
        <slot />
      </div>
    </template>
  </div>
</template>

<script lang="ts" setup>
defineProps<{
  id: string;
  link: boolean;
}>();
</script>
